import {
  PAUSE_NOTIFICATIONS,
  REMOVE_NOTIFICATION,
  RESUME_NOTIFICATIONS,
  SET_NOTIFICATION
} from '../constants';
import createPauseNotificationsState from './createPauseNotificationsState';
import createRemoveNotificationState from './createRemoveNotificationState';
import createResumeNotificationsState from './createResumeNotificationsState';
import createSetNotificationState from './createSetNotificationState';

export default (state, action) => {
  const { type, payload } = action;

  switch (type) {
    case PAUSE_NOTIFICATIONS:
      return createPauseNotificationsState(state, payload);

    case RESUME_NOTIFICATIONS:
      return createResumeNotificationsState(state, payload);

    case SET_NOTIFICATION:
      return createSetNotificationState(state, payload);

    case REMOVE_NOTIFICATION:
      return createRemoveNotificationState(state, payload);

    default:
      return state;
  }
};
